import React, { useState, useEffect } from 'react';
import StarRating from '../Rating/StarRating'
import WithdrawServices from '../../services/WithdrawServices';

function UpdateWithdraw({ withdraw, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        remark: '',
        paymentMethod: '',
        paymentDate: '',
        transactionId: '',
        payType: '',
        amount: '',
    });
    useEffect(() => {
        if (withdraw) {
            setFormValues({
                remark: withdraw?.remark || '',
                paymentMethod: withdraw?.paymentMethod || '',
                paymentDate: withdraw?.paymentDate || '',
                transactionId: withdraw?.transactionId || '',
                payType: withdraw?.payType || '',
                amount: withdraw?.amount || '',
            });
        }
    }, [withdraw]);
    if (!withdraw) return null;
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }

            await WithdrawServices.updateWithdraw(withdraw._id, formValues);
            alert('Withdraw updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.log(error);
            alert(error.response?.data?.message ||'Failed to update Withdraw');
        }
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${day}-${month}-${year}`;
    };
    const url = 'uploads/';


    return (
        <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="manufacturerModal">payment Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        <div className="container">

                            <div className="page-details">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Payment Method</label>
                                                <select className="form-control" value={formValues.paymentMethod}
                                                    onChange={handleInputChange} name="paymentMethod">
                                                    <option >Select Payment Method</option>
                                                    <option value="Cehque">Cehque</option>
                                                    <option value="Cash">Cash</option>
                                                    <option value="Transfer">Transfer</option>
                                                </select>

                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Amount Pay Type</label>
                                                <select className="form-control" value={formValues.payType}
                                                    onChange={handleInputChange} name="payType">
                                                    <option >Select Type</option>
                                                    <option value="Full">Full</option>
                                                    <option value="Partial">Partial</option>
                                                </select>

                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Amounts</label>
                                                <input type="number" name="amount" className="form-control" value={formValues.amount} onChange={handleInputChange} placeholder="Enter Amount" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Transaction No.</label>
                                                <input type="number" name="transactionId" className="form-control" value={formValues.transactionId} onChange={handleInputChange} placeholder="Enter Transaction No." />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Payment Date</label>
                                                <input type="date" name="paymentDate" className="form-control" value={formValues.paymentDate} onChange={handleInputChange} placeholder="dd-mm-yyyy" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>User Name</label>
                                                <input type="text" name="username" className="form-control" value={withdraw.investor.name} onChange={handleInputChange} placeholder="Enter username" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-sm-12">
                                            <div className="input-field">
                                                <label>Remark</label>
                                                <textarea rows="3" style={{ height: 'auto' }} type="text" name="remark" value={formValues.remark} onChange={handleInputChange} className="form-control" placeholder="New Remark" />
                                            </div>
                                        </div>


                                    </div>
                                    <button className="site-btn-green">Save & Close</button>
                                </form>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div >
    );
}

export default UpdateWithdraw;
